import { useMemo } from "react";
import { useGlobalMDAlert } from "context";

/**
 * Toasts estándar sobre el GlobalMDAlert existente. Reemplaza los alert():
 *
 *   const toast = useToast();
 *   toast.exito("Gasto eliminado");
 *   toast.error(data?.Error || "No se pudo eliminar el gasto");
 *   toast.aviso("Seleccione un rango de fechas");
 */
export default function useToast() {
  const { showAlert } = useGlobalMDAlert();
  return useMemo(
    () => ({
      exito: (message) => showAlert({ message, color: "success", autoHideDuration: 3000 }),
      error: (message) => showAlert({ message, color: "error", autoHideDuration: 5000 }),
      aviso: (message) => showAlert({ message, color: "warning", autoHideDuration: 4000 }),
    }),
    [showAlert]
  );
}
